import React from 'react';
import KDSPage from 'pages/kds';

function KDS() {
  return <KDSPage />;
}

export default KDS;
